// extracted by mini-css-extract-plugin
module.exports = {"Loader":"styles_Loader__2hizZ","Loader-image":"styles_Loader-image__37dTd","Loader--large":"styles_Loader--large__-zgr4","Loader--center":"styles_Loader--center__2kv3J"};